<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="title"
  width="920"
)
  XmlViewer(:xml="file_content")
</template>

<script>
import ApiMaventaSalesInvoices from "@/api/maventaSalesInvoices.js";
import XmlViewer from "@/components/XMLViewer/XmlViewer.vue";

export default {
  components: {
    XmlViewer,
  },

  data() {
    return {
      show: false,
      title: this.$t("companies.maventa_invoices.title"),
      inProgress: false,
      file_content: "",
    };
  },

  methods: {
    open(invoiceId) {
      this.show = true;
      this.inProgress = true;
      ApiMaventaSalesInvoices.fetchInvoice(
        this.$route.params.id,
        invoiceId,
      ).then((resp) => {
        this.file_content = resp.data.maventa_sales_invoice.original_record;
        console.log(this.file_content);
        this.title =
          this.$t("companies.maventa_invoices.title") +
          " " +
          resp.data.maventa_sales_invoice.invoice_number;
        this.inProgress = false;
      });
    },

    close() {
      this.show = false;
    },
  },
};
</script>
